import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { analyticsUserTrack } from "../../config/analyticsTrack";
import Config from "../../helper/Config";

const ImageSlider = (props) => {
    let { images } = props;
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
        arrows: true,
        dots: true,
    };


    return <div className="slider-container">
        <Slider {...settings}>
            {
                images.map((item, index) => {
                    let { file, name, position, year, id } = item
                    return <div key={index} className="parent" onClick={() => {
                        props.history.push(Config.projectUrl + "/teqed-change-makers/"+id)
                        analyticsUserTrack("Teqed Change Makers", "Clicked - "+name);
                    }}>
                        <div className="year">{year}</div>
                        <img className="img-fluid slide-image" src={file} style={{ objectPosition: position ? position : "50% 50%"}}/>
                        <div className="name">{name}</div>
                        
                    </div>
                })
            }
        </Slider>
    </div>
};

export default ImageSlider;